import { songPath } from "../assets/songPath";
export const SongsData = [
  {
    id: "1",
    title: "Let me love you",
    artist: "Justin Beaver",
    playing: "1,040,811,084",
    time: "3:26",
    album: "Thriller 25 Super Deluxe Edition",
    cover: "https://www.pagalworld.com.sb/siteuploads/thumb/sft14/6511_4.jpg",
    song: songPath.letMeLoveYou,
  },
  {
    id: "2",
    title: "Yesterday",
    artist: "Ali Gatie, Alan Walker",
    playing: "407,234,004",
    time: "	2:41",
    album: "Yesterday Mp3 Download Ali Gatie, Alan Walker",
    cover: "https://www.pagalworld.com.sb/siteuploads/thumb/sft137/68379_4.jpg",
    song: songPath.Yesterday,
  },
  {
    id: "3",
    title: "On My Way",
    artist: "Alan Walker, Sabrina Carpenter, Farruko",
    playing: "316,391,952",
    time: "3:14",
    album: "On My Way Mp3 Download Alan Walker, Sabrina Carpenter, Farruko",
    cover: "https://www.pagalworld.com.sb/siteuploads/thumb/sft136/67774_4.jpg",
    song: songPath.OnMyWay,
  },
  {
    id: "4",
    title: "Deva Deva",
    artist: "Emma Heesters",
    playing: "643,786,045",
    time: "3:50",
    album: "DEVA DEVA - (English Version) Mp3 Download Emma Heesters",
    cover: "https://www.pagalworld.com.sb/siteuploads/thumb/sft129/64387_4.jpg",
    song: songPath.deva_deva,
  },
  {
    id: "5",
    title: "Don't You Hold Me Down",
    artist: "Alan Walker, Georgia Ku",
    playing: "268,187,218",
    time: "2:25",
    album: "Don't You Hold Me Down Mp3 Download Alan Walker, Georgia Ku",
    cover: "https://www.pagalworld.com.sb/siteuploads/thumb/sft8/3514_4.jpg",
    song: songPath.DontYouHoldMe,
  },
  {
    id: "6",
    title: "Let Me Down Slowly",
    artist: "Alec Benjamin",
    playing: "316,391,952",
    time: "2:57",
    album:
      "Let Me Down Slowly Song Download, let me down slowly (female version)",
    cover: "https://www.pagalworld.com.sb/siteuploads/thumb/sft12/5637_4.jpg",
    song: songPath.LetMeDownSlowly,
  },
  {
    id: "7",
    title: "Lala Li Lala",
    artist: "Aca Xoca",
    playing: "316,352",
    time: "3:51",
    album: "Lala Li Lala Song by Aca Xoca, La La La Li La La La Song",
    cover: "https://www.pagalworld.com.sb/siteuploads/thumb/sft11/5382_4.jpg",
    song: songPath.LalaLiLala,
  },
  {
    id: "8",
    title: "Uhh na na na na",
    artist: "Dharia",
    playing: "268,187,218",
    time: "3:21",
    album: "Uhh na na na na na uhh na na na na na Uhh na na na na uh",
    cover: "https://www.pagalworld.com.sb/siteuploads/thumb/sft14/6895_4.jpg",
    song: songPath.UhhNaiNa,
  },
  {
    id: "9",
    title: "Tus Besos",
    artist: "Freebot",
    playing: "678,352,342",
    time: "3:00",
    album: "Tus Besos Song Download, TikTok, Instagram Viral Dance Music",
    cover: "https://www.pagalworld.com.sb/siteuploads/thumb/sft13/6156_4.jpg",
    song: songPath.TusBesos,
  },
  {
    id: "10",
    title: "Light The Sky",
    artist: "Rahma Riad, Manal",
    playing: "767,445,321",
    time: "4:19",
    album: "Nora Fatehi, FIFA World Cup Qatar 2022",
    cover: "https://www.pagalworld.com.sb/siteuploads/thumb/sft130/64618_4.jpg",
    song: songPath.LightTheSky,
  },
];
